<mat-form-field *ngIf="!selectedUser" appearance="outline" class="search-field">
  <mat-label>{{ label | traduccion }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="searchCtrl"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    autocomplete="off" />
  <button *ngIf="searchCtrl.value" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-progress-spinner *ngIf="loading$ | async" matSuffix mode="indeterminate" diameter="18"></mat-progress-spinner>
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser">
  <mat-option *ngFor="let user of users$ | async" [value]="user" (onSelectionChange)="onPick(user, $event)">
    <div class="option-row">
      <mat-icon>person</mat-icon>
      <div class="option-col">
        <div class="name">{{ user.username }}</div>
        <div class="meta">{{ user.email }} · {{ user.username || '-' }} · ID: {{ user.id }}</div>
      </div>
    </div>
  </mat-option>

  <mat-option *ngIf="searchTerm.trim().length >= minChars && (users$ | async)?.length === 0 && !(loading$ | async)" disabled>
    {{ noDataLabel | traduccion }}
  </mat-option>
</mat-autocomplete>

<mat-chip-listbox *ngIf="selectedUser" class="selected-user-chip">
  <mat-chip-row color="primary" selected>
    <mat-icon>person</mat-icon>
    {{ selectedUser.username }} · {{ selectedUser.email }} · ID: {{ selectedUser.id }}
    <button mat-icon-button (click)="clear()" aria-label="Quitar">
      <mat-icon>close</mat-icon>
    </button>
  </mat-chip-row>
</mat-chip-listbox>
